var exports = {
  "kL": "container__rVy3su",
  "wx": "header__vly12b",
  "Vg": "grid__gPnKls",
  "Li": "itemHeader__vkaw76",
  "Fx": "itemIcon__u6Derj",
  "wp": "itemTitle__0f4ABR",
  "sc": "itemBody__RfvjK9",
  "t3": "itemFooterRow__ArjTKS",
  "$T": "itemFooter__H54wbY",
};

module.exports = exports;
